/*
============================================
CLUSTER A/B TEST: Cart Trust Elements
Test ID: 2ee10881-8757-4572-8de3-e536f0f2ff20
Control Variant ID: 6e1ceee7-0f0f-482b-9e2d-912331069c04
Treatment Variant ID: ed5d6df2-8813-4537-8027-2477c6869fba
============================================
*/
(function() {
  if (window.location.pathname !== '/cart') return;

  var TEST_ID = '2ee10881-8757-4572-8de3-e536f0f2ff20';
  var CONTROL_VARIANT_ID = '6e1ceee7-0f0f-482b-9e2d-912331069c04';
  var TREATMENT_VARIANT_ID = 'ed5d6df2-8813-4537-8027-2477c6869fba';
  var currentVariant = 'control';

  function getAssignments() {
    if (window.cluster_ctx && Array.isArray(window.cluster_ctx.assignments)) {
      return window.cluster_ctx.assignments;
    }
    if (window.__clusterDebug && Array.isArray(window.__clusterDebug.assignments)) {
      return window.__clusterDebug.assignments;
    }
    return null;
  }

  function getAssignedVariant() {
    var assignments = getAssignments();
    if (!assignments) return null;

    for (var i = 0; i < assignments.length; i++) {
      var assignment = assignments[i];
      if (!assignment || assignment.testId !== TEST_ID) continue;

      if (assignment.variantId === TREATMENT_VARIANT_ID) return 'treatment';
      if (assignment.variantId === CONTROL_VARIANT_ID) return 'control';

      if (assignment.variant && typeof assignment.variant.isControl === 'boolean') {
        return assignment.variant.isControl ? 'control' : 'treatment';
      }
    }

    return null;
  }

  function applyVariant(variant) {
    currentVariant = variant === 'treatment' ? 'treatment' : 'control';
    document.documentElement.classList.toggle(
      'is-cart-trust-treatment',
      currentVariant === 'treatment'
    );
  }

  function resolveAndApply() {
    var assignedVariant = getAssignedVariant();
    applyVariant(assignedVariant || 'control');
    return assignedVariant;
  }

  window.isCartTrustTreatment = function() {
    return currentVariant === 'treatment';
  };

  function initStickyCheckout() {
    var checkoutButtons = document.querySelector('.checkout-buttons');
    if (!checkoutButtons || document.querySelector('.sticky-checkout-bar')) return;

    var originalButton = checkoutButtons.querySelector('button, input[type="submit"], [type="submit"], a');
    if (!originalButton) return;

    var style = document.createElement('style');
    style.innerHTML = `
      .sticky-checkout-bar {
        position: fixed;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: 999;
        padding: 12px;
        background: #fff;
        box-shadow: 0 -2px 12px rgba(0, 0, 0, 0.08);
        transform: translateY(100%);
        transition: transform 0.2s ease;
      }

      .sticky-checkout-bar.is-visible {
        transform: translateY(0);
      }

      .sticky-checkout-button {
        width: 100%;
      }

      body.has-sticky-checkout {
        padding-bottom: 80px;
      }
    `;
    document.head.appendChild(style);

    var stickyBar = document.createElement('div');
    stickyBar.className = 'sticky-checkout-bar';
    stickyBar.innerHTML = '<button type="button" class="sticky-checkout-button"></button>';
    document.body.appendChild(stickyBar);

    var stickyButton = stickyBar.querySelector('.sticky-checkout-button');

    function syncStickyButton() {
      stickyButton.textContent = originalButton.textContent
        ? originalButton.textContent.trim()
        : 'Checkout';

      stickyButton.className = (originalButton.className || '') + ' sticky-checkout-button';
      stickyButton.disabled = !!originalButton.disabled;
      stickyButton.style.display =
        window.getComputedStyle(originalButton).display === 'none' ? 'none' : '';
    }

    function toggleSticky() {
      var rect = checkoutButtons.getBoundingClientRect();
      var inView = rect.top < window.innerHeight && rect.bottom > 0;

      if (!inView) {
        stickyBar.classList.add('is-visible');
        document.body.classList.add('has-sticky-checkout');
      } else {
        stickyBar.classList.remove('is-visible');
        document.body.classList.remove('has-sticky-checkout');
      }
    }

    syncStickyButton();
    toggleSticky();

    var observer = new MutationObserver(function() {
      syncStickyButton();
      toggleSticky();
    });

    observer.observe(originalButton, {
      attributes: true,
      childList: true,
      subtree: true
    });

    // ✅ scroll only (no click)
    stickyButton.addEventListener('click', function() {
      if (!originalButton) return;

      originalButton.scrollIntoView({
        behavior: 'smooth',
        block: 'center'
      });
    });

    window.addEventListener('scroll', toggleSticky, { passive: true });
    window.addEventListener('resize', function() {
      syncStickyButton();
      toggleSticky();
    });
  }

  resolveAndApply();

  var attempts = 0;
  var maxAttempts = 80;
  var pollInterval = setInterval(function() {
    attempts += 1;
    var assignedVariant = getAssignedVariant();

    if (assignedVariant) {
      applyVariant(assignedVariant);
      clearInterval(pollInterval);

      if (assignedVariant === 'treatment') {
        initStickyCheckout();
      }
      return;
    }

    if (attempts >= maxAttempts) {
      clearInterval(pollInterval);

      if (currentVariant === 'treatment') {
        initStickyCheckout();
      }
    }
  }, 250);

  if (currentVariant === 'treatment') {
    initStickyCheckout();
  }
})();